import { render, staticRenderFns } from "./cybchat.vue?vue&type=template&id=5b978dfd&scoped=true&"
import script from "./cybchat.vue?vue&type=script&lang=js&"
export * from "./cybchat.vue?vue&type=script&lang=js&"
import style0 from "./cybchat.vue?vue&type=style&index=0&id=5b978dfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b978dfd",
  null
  
)

export default component.exports